module.exports = __webpack_public_path__ + "assets/07302ffbf793b509b167db2fec2fdbe5.png";